module.exports = __webpack_public_path__ + "img/banner-programacion.a47edf20.jpg";